module.exports = __webpack_public_path__ + "static/media/bannerbigsee-23.a41ce189.jpg";